<template>
	<div class="container">
    <mt-header class="header" fixed title="付款码">
			<header-item slot="left" v-bind:isBack=true v-on:onclick="goBack"></header-item>		
		</mt-header>    
    <div class="top-wrapper"> 
      <div class="icon" id="qrcode"></div>
    </div> 
    <gk-button  style="color:#fff;background-color:#FA800A" class="button bottom-button" v-on:click="goBack">返回</gk-button>		    
	</div>
</template>

<script>
import { HeaderItem, Button } from '../../components/common'
import { getPaymentCode } from '../../api/user'
import { Indicator, Toast } from 'mint-ui'
import QRCode from 'qrcodejs2'
export default {
  name: 'PaymentCode',
  data() {
    return {
      paycode: '',
      job:null,
    }
  },
  created() {
    Indicator.open()
    this.job = setInterval(this.getPayment(),1000)
  },
  destroyed(){
    if(this.job){
      clearInterval(this.job)
    }
  },
	methods: {
		goBack() {
			this.$router.go(-1)
    },
    getPayment(){
      console.dir(this)
      getPaymentCode().then(res => {
        Indicator.close()
        if (res.error_code ==0) {
          this.paycode = res.paycode
          let qrcode = new QRCode('qrcode', {
            width: 192,
            height: 192, // 高度
            text: this.paycode, // 二维码内容
          })
        }
      }, error => {
        Indicator.close()
        Toast('请求异常:'+error.errorMsg)
      })
    }
	}
}
</script>

<style scoped lang="scss">
.container {
  position: relative;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: stretch;
	background-color: $mainbgColor;	
  height: 100%;
}
.top-wrapper {  
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: center;	
}
.header {
	@include header;
	border-bottom: 1px solid $lineColor;
}
.icon {
  width: 192px;
  height: 192px;
  margin-top: 100px;
}
.desc {
	color: #A4AAB3;
  font-size: 16px;
	margin-top: 16px;
	text-align: center;
}
.title {
	color: $primaryColor;
  font-size: 50px;
	margin-top: 5px;
	text-align: center;
}
.button {
	@include button;  
}
.top-button {	
	margin-top: 25px;
}
.bottom-button {	
  margin-top: 100px;
}
.bottom-wrapper {
  position: absolute;
  left: 0px;
  bottom: 0px;
  right: 0px;
  height: 44px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;  
}
.bottom-item {
  font-size: 14px;
  color: #666666;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/page/payment-code/PaymentCode.vue